import { Component } from '@theme/component';

class AdditionalInfoBlock extends Component {
  #previousFocus = null;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('keydown', this.#boundKeydown);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('keydown', this.#boundKeydown);
  }

  handleOpenModal() {
    if (!this.refs.modal) return;
    this.#previousFocus = document.activeElement;
    this.refs.modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    this.refs.closeBtn.focus();
  }

  handleCloseModal() {
    if (!this.refs.modal) return;
    this.refs.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    this.#previousFocus?.focus();
  }

  handleOverlayClick() {
    this.handleCloseModal();
  }

  #boundKeydown = (event) => {
    if (event.key !== 'Escape') return;
    if (this.refs.modal?.getAttribute('aria-hidden') === 'true') return;
    this.handleCloseModal();
  };
}

if (!customElements.get('additional-info-block')) {
  customElements.define('additional-info-block', AdditionalInfoBlock);
}
